<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
    <path fill="currentColor" fill-rule="evenodd" d="M16 .333a1 1 0 011 1v29.334a1 1 0 11-2 0V1.333a1 1 0 011-1z" clip-rule="evenodd" />
    <path fill="currentColor" fill-rule="evenodd" d="M8.66 7.326a5.667 5.667 0 014.007-1.66h10a1 1 0 110 2h-10a3.667 3.667 0 000 7.334h6.666a5.667 5.667 0 110 11.333H8a1 1 0 110-2h11.333a3.667 3.667 0 000-7.333h-6.666A5.667 5.667 0 018.66 7.326z" clip-rule="evenodd" />
  </svg>
</template>
